var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasCylinders(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.3,37.3h5.9c0.9,0,1.6-0.7,1.7-1.6V16.4c0-2.4-1.9-4.4-4.3-4.5v-1.2h1.6c0.6,0,1.1-0.5,1.1-1.1V8.8 c0-0.6-0.5-1.1-1.1-1.1h-3.9c-0.6,0.1-1,0.5-1,1.1v0.8c0,0.6,0.4,1,1,1.1h1.6v1.2C9.5,12,7.7,14,7.7,16.4v19.4 C7.7,36.6,8.4,37.3,9.3,37.3z M10.3,9.9c-0.2,0-0.3-0.1-0.3-0.3V8.6c0-0.2,0.1-0.3,0.3-0.3h3.9c0.2,0,0.3,0.1,0.3,0.3v0.9 c0,0.2-0.1,0.3-0.3,0.3H10.3z M8.4,16.4c0-2.1,1.7-3.8,3.8-3.8h0.2c2.1,0.1,3.7,1.7,3.7,3.8v3.2H8.4V16.4z M8.4,20.4h7.7v9.9H8.4 V20.4z M8.4,30.9h7.7v4.8c0,0.4-0.4,0.8-0.8,0.8c0,0-0.1,0-0.1,0H9.3c-0.4,0.1-0.8-0.3-0.9-0.7c0,0,0-0.1,0-0.1V30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.1,30.3v-9.9H8.4v9.9H16.1z M12.3,22.8c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5 c-1.4,0-2.5-1.1-2.5-2.5C9.8,23.9,10.9,22.8,12.3,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.4,35.9c0.1,0.4,0.5,0.7,0.9,0.7h5.9c0,0,0.1,0,0.1,0c0.4,0,0.8-0.4,0.8-0.8v-4.8H8.4v4.8 C8.4,35.8,8.4,35.8,8.4,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.1,19.6v-3.2c0-2.1-1.6-3.7-3.7-3.8h-0.2c-2.1,0-3.8,1.7-3.8,3.8v3.2H16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M14.2,9.9c0.2,0,0.3-0.1,0.3-0.3V8.6c0-0.2-0.1-0.3-0.3-0.3h-3.9c-0.2,0-0.3,0.1-0.3,0.3v0.9 c0,0.2,0.1,0.3,0.3,0.3H14.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#28B557",
    cx: 12.3,
    cy: 25.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.5,37.3h6c0.9,0,1.6-0.7,1.6-1.6V16.4c0-2.4-1.8-4.3-4.2-4.5v-1.2h1.6c0.6-0.1,1-0.5,1-1.1V8.8 c0-0.6-0.4-1-1-1.1h-3.9c-0.6,0-1.1,0.5-1.1,1.1v0.8c0,0.6,0.5,1.1,1.1,1.1h1.5v1.2c-2.4,0.2-4.2,2.1-4.2,4.5v19.4 C17.9,36.6,18.6,37.3,19.5,37.3z M20.6,9.9c-0.2,0-0.3-0.1-0.3-0.3V8.6c0-0.2,0.1-0.3,0.3-0.3h3.9c0.2,0,0.3,0.1,0.3,0.3v0.9 c0,0.2-0.1,0.3-0.3,0.3H20.6z M18.7,16.4c0-2.1,1.6-3.7,3.7-3.8h0.2c2,0,3.7,1.7,3.7,3.7c0,0,0,0.1,0,0.1v3.2h-7.6V16.4z  M18.7,20.4h7.6v9.9h-7.6V20.4z M18.7,30.9h7.7v4.8c-0.1,0.5-0.4,0.8-0.9,0.8h-6c-0.4,0-0.8-0.4-0.8-0.8V30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.5,9.9c0.2,0,0.3-0.1,0.3-0.3V8.6c0-0.2-0.1-0.3-0.3-0.3h-3.9c-0.2,0-0.3,0.1-0.3,0.3v0.9 c0,0.2,0.1,0.3,0.3,0.3H24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.3,30.3v-9.9h-7.6v9.9H26.3z M22.5,22.8c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5 c-1.4,0-2.5-1.1-2.5-2.5C20,23.9,21.1,22.8,22.5,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.5,36.6h6c0.5,0,0.8-0.3,0.9-0.8v-4.8h-7.7v4.8C18.7,36.2,19.1,36.6,19.5,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.3,19.6v-3.2c0,0,0-0.1,0-0.1c0-2-1.7-3.7-3.7-3.7h-0.2c-2.1,0.1-3.7,1.7-3.7,3.8v3.2H26.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4AB8DC",
    cx: 22.5,
    cy: 25.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M33.1,11.9v-1.2h1.6c0.6,0,1.1-0.5,1.1-1.1V8.8c0-0.6-0.5-1.1-1.1-1.1h-3.9c-0.6,0-1,0.4-1,1 c0,0,0,0.1,0,0.1v0.8c-0.1,0.5,0.3,1,0.9,1.1c0,0,0.1,0,0.1,0h1.6v1.2C30,12,28.1,14,28.2,16.4v19.4c0,0.9,0.7,1.6,1.6,1.6h5.9 c0.9,0,1.6-0.7,1.6-1.6V16.4C37.4,14,35.5,12,33.1,11.9z M30.8,9.9c-0.2,0-0.3-0.1-0.3-0.3V8.6c0-0.2,0.1-0.3,0.3-0.3h3.9 c0.2,0,0.3,0.1,0.3,0.3v0.9c0,0.2-0.1,0.3-0.3,0.3H30.8z M36.6,35.8c0,0.4-0.4,0.8-0.8,0.8c0,0-0.1,0-0.1,0h-5.9 c-0.4,0.1-0.8-0.3-0.9-0.7c0,0,0-0.1,0-0.1v-4.8h7.7V35.8z M36.6,30.3h-7.7v-9.9h7.7V30.3z M36.6,16.4v3.2h-7.7v-3.2 c0-2.1,1.7-3.8,3.8-3.8h0.1C34.9,12.6,36.6,14.3,36.6,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.9,20.4v9.9h7.7v-9.9H28.9z M32.8,27.8c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5 c1.4,0,2.5,1.1,2.5,2.5C35.3,26.6,34.2,27.8,32.8,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.9,30.9v4.8c0,0,0,0.1,0,0.1c0.1,0.4,0.5,0.7,0.9,0.7h5.9c0,0,0.1,0,0.1,0c0.4,0,0.8-0.4,0.8-0.8v-4.8 H28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.8,12.6L32.8,12.6c-2.2,0-3.9,1.7-3.9,3.8v3.2h7.7v-3.2C36.6,14.3,34.9,12.6,32.8,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M35,9.6V8.6c0-0.2-0.1-0.3-0.3-0.3h-3.9c-0.2,0-0.3,0.1-0.3,0.3v0.9c0,0.2,0.1,0.3,0.3,0.3h3.9 C34.9,9.9,35,9.7,35,9.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F2724A",
    cx: 32.8,
    cy: 25.3,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasCylinders);
export default __webpack_public_path__ + "static/media/gas_cylinders.f297dc0b32313ee8d403490d3d15ae33.svg";
export { ForwardRef as ReactComponent };